export function formatPrice(amount, currency) {
  const formattedCurrency = currency === "BAM" ? "KM" : currency;

  return `${amount.toFixed(2)} ${formattedCurrency}`;
}
